import { useEffect } from 'react';

const DEFERRED_RESIZE_MESSAGES = new Set([
  'ResizeObserver loop limit exceeded',
  'ResizeObserver loop completed with undelivered notifications.',
]);

// Native ResizeObserver diagnostics mean delivery was deferred to the next
// paint, not that the table operation threw. Keep them out of the development
// error overlay on AirPlus only; never swallow an actual JavaScript exception.
export function handleAirPlusResizeDiagnostic(event) {
  if (!/^\/air-plus(?:\/|$)/.test(window.location.pathname) ||
      event.error != null || !DEFERRED_RESIZE_MESSAGES.has(event.message)) return;
  event.preventDefault();
  event.stopImmediatePropagation();
}

export default function useAirPlusResizeDiagnostics() {
  useEffect(() => {
    // Capture before the development overlay's bubbling error listener.
    window.addEventListener('error', handleAirPlusResizeDiagnostic, true);
    return () => window.removeEventListener('error', handleAirPlusResizeDiagnostic, true);
  }, []);
}
